export const TabCourse = {
  courseInfo: 'courseInfo',
  detailGV_HV: 'detailGV_HV',
  detailLesson: 'detailLesson',
}
